module.exports = __webpack_public_path__ + "static/media/sign_fail.9967bbef.png";